import { useContext } from 'react';
import { NotificationContext } from '../context/notification-context';

const useNotificationsContext = () => useContext(NotificationContext);

export default useNotificationsContext;
